import { defineNuxtPlugin } from "#app"
import { VueReCaptcha } from "vue-recaptcha-v3"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueReCaptcha, {
    siteKey: "6LdWRcgUAAAAAANGoeH69l-tWg3JU_mzxPRZjB5x",
    loaderOptions: {
      autoHideBadge: true,
    },
  })
})
